<template>
  <v-dialog
    v-model="opened"
    content-class="update-city-dialog"
    max-width="350"
    persistent
  >
    <h3 class="update-city-dialog__title">{{ $t('common.btns.edit') }}</h3>

    <v-btn class="close-btn" icon @click="opened = false">
      <v-icon size="27" color="#464646"> mdi-close-circle-outline </v-icon>
    </v-btn>

    <v-form ref="update-city-form" class="mt-5" @submit.prevent="onSubmit">
      <v-select
        v-model="formData.city_id"
        item-text="name"
        item-value="id"
        dense
        outlined
        :label="$t('finance.city')"
        :items="cities"
        :rules="[isRequired]"
        :disabled="officeOnly"
      />

      <v-select
        v-model="formData.office_id"
        item-text="name"
        item-value="id"
        dense
        outlined
        :label="$t('finance.office')"
        :items="offices"
        :disabled="!formData.city_id"
        :rules="[isRequired]"
      />

      <v-btn
        type="submit"
        color="warning"
        elevation="0"
        block
        :loading="loading"
      >
        {{ $t('common.btns.save') }}
      </v-btn>
    </v-form>
  </v-dialog>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    cityId: {
      type: [Number, String],
      required: true,
    },
    officeId: {
      type: [Number, String],
      required: true,
    },
    itemId: {
      type: [Number, String],
      required: true,
    },
    officeOnly: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    loading: false,

    formData: {
      city_id: '',
      office_id: '',
    },
  }),
  watch: {
    opened(val) {
      if (!val) {
        this.$refs['update-city-form'].reset();
        this.loading = false;
        return;
      }

      this.formData.city_id = this.cityId;
      this.formData.office_id = this.officeId;
    },
    'formData.city_id': {
      handler(_, oldValue) {
        if (oldValue) {
          this.formData.office_id = '';
        }
      },
    },
  },
  computed: {
    opened: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('change', val);
      },
    },
    cities() {
      return this.$store.state['company-expenses'].citiesList;
    },
    offices() {
      const currentCity = this.cities.find(
        ({ id }) => id === this.formData.city_id,
      );
      return currentCity ? currentCity.offices : [];
    },
  },
  methods: {
    isRequired(v) {
      return !!v || this.$t('common.fields.validation.field.required');
    },
    onSubmit() {
      const isValid = this.$refs['update-city-form'].validate();

      if (!isValid) return;

      this.loading = true;
      this.$emit('save', {
        params: this.formData,
        id: this.itemId,
      });
    },
  },
};
</script>

<style lang="scss">
.update-city-dialog {
  padding: 10px;
  background-color: #fff;
}
</style>
